export default __webpack_public_path__ + "static/nextgen-banner-2-2de85d120098db153bd8c67b29f03e15.webp";